import { defineComponent as _defineComponent } from 'vue';
import { computed, toRef, watch } from "vue";
import { useJobStore } from "@/stores/jobStore";
import { useMappingJobs } from "./handlesMappingJobs";
import JobSelection from "./JobSelection.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolStd',
    props: {
        jobId: { default: null },
        implicitCollectionJobsId: { default: null },
        name: null
    },
    setup(__props) {
        const props = __props;
        const jobStore = useJobStore();
        const jobIdRef = toRef(props, "jobId");
        const implicitCollectionJobsIdRef = toRef(props, "implicitCollectionJobsId");
        const { selectJobOptions, selectedJob, targetJobId } = useMappingJobs(jobIdRef, implicitCollectionJobsIdRef);
        async function init() {
            if (targetJobId.value) {
                jobStore.fetchJob(targetJobId.value);
            }
        }
        watch(targetJobId, () => {
            init();
        }, { immediate: true });
        const jobContent = computed(() => {
            let content;
            if (targetJobId.value) {
                const job = jobStore.getJob(targetJobId.value);
                content = job && job[props.name];
            }
            if (!content && props.name == "tool_stdout") {
                content = "*No Standard Output Available*";
            }
            else if (!content) {
                content = "*No Standard Error Available*";
            }
            return content;
        });
        return { __sfc: true, props, jobStore, jobIdRef, implicitCollectionJobsIdRef, selectJobOptions, selectedJob, targetJobId, init, jobContent, JobSelection };
    }
});
